"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const luxon_1 = require("luxon");
const TimeSeriesStub_1 = __importDefault(require("../stub/TimeSeriesStub"));
const getValues = ({ start, end, type, }) => {
    const startDay = luxon_1.DateTime.fromISO(start);
    const endDay = luxon_1.DateTime.fromISO(end);
    const diff = endDay.diff(startDay, [type]).toObject();
    const values = [];
    for (let i = 0; i < Math.round(diff[type]); i++) {
        values.push(new TimeSeriesStub_1.default({
            datetime: startDay.plus({ [type]: i }),
            // value: faker.random.number(100),
            value: startDay.plus({ [type]: i }).day * 100,
        }));
    }
    return values;
};
exports.default = getValues;
